import React from "react";
import { getTabsForRole } from "../../config/navigation";

const Navigation = ({ role, activeTab, onTabChange, scope = "global" }) => {
  const tabs = getTabsForRole(role).filter((tab) => {
    if (scope === "global") {
      return [
        "dashboard",
        "projects",
        "analytics",
        "users",
        "audit-logs",
        "bug-reports",
        "ai-usage",
      ].includes(tab.id);
    }
    return false;
  });

  return (
    <nav className="bg-white shadow-md">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex space-x-1 overflow-x-auto">
          {tabs.map((tab) => {
            const Icon = tab.icon;
            return (
              <button
                key={tab.id}
                type="button"
                onClick={() => onTabChange(tab.id)}
                className={`flex items-center space-x-2 px-4 py-4 font-medium border-b-2 transition-colors whitespace-nowrap ${
                  activeTab === tab.id
                    ? "border-orange-500 text-orange-600"
                    : "border-transparent text-gray-600 hover:text-gray-900"
                }`}
              >
                <Icon className="w-4 h-4" />
                <span className="text-sm">{tab.label}</span>
              </button>
            );
          })}
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
